function VideoTracking() {
  var divisor = 10,
      videos_status = {},
      dataLayer = window.dataLayer;

  var videos = document.getElementsByTagName( "video" );

  window.vimeoCallback = function( e ) {
    videos_status[ videoID ].title = e[ "title" ];
  };

  for ( var i = 0; i < videos.length; i++ ) {
    var url = videos[ i ].getAttribute( "src" );
    if ( /player\.vimeo\.com/.test( url ) ) {
      var videoID = url.split( "?" )[ 0 ].split( "/" ).pop().replace( ".hd.mp4", "" );
      videos[ i ].setAttribute( "id", videoID );
    } else {
      return;
    }
    videos_status[ videoID ] = {};
    videos_status[ videoID ].id = videoID;
    getVimeoInfo( videoID, window.vimeoCallback );
    videos_status[ videoID ].greatest_marker = 0;
    videos_status[ videoID ]._progress_markers = {};

    for ( j = 0; j < 100; j++ ) {
      videos_status[ videoID ].progress_point = divisor * Math.floor( j / divisor );
      videos_status[ videoID ]._progress_markers[ videos_status[ videoID ].progress_point ] = false;
    }
    videos_status[ videoID ].current = 0;

    videos[ i ].addEventListener("play", eventHandler, false );
    videos[ i ].addEventListener("pause", eventHandler, false );
    videos[ i ].addEventListener("ended", eventHandler, false );
    videos[ i ].addEventListener("timeupdate", eventHandler, false );
    videos[ i ].addEventListener("ended", eventHandler, false );
  }

  function getVimeoInfo( videoID, callback ) {
    var script = document.createElement( "script" );
    script.type = "text/javascript";
    script.src = "https://www.vimeo.com/api/oembed.json?url=https://vimeo.com/" + videoID + "&callback=vimeoCallback";
    document.getElementsByTagName( "body" )[ 0 ].appendChild( script );
  }

  function eventHandler( e ) {
    switch ( e.type ) {
      case "timeupdate":
        videos_status[ e.target.id ].current = Math.round( e.target.currentTime );
        var pct = Math.floor( 100 * videos_status[ e.target.id ].current / e.target.duration );
        for ( var j in videos_status[ e.target.id ]._progress_markers ) {
          if ( pct >= j && j > videos_status[ e.target.id ].greatest_marker ) {
            videos_status[ e.target.id ].greatest_marker = j;
          }
        }
        if ( videos_status[ e.target.id ].greatest_marker && !videos_status[ e.target.id ]._progress_markers[ videos_status[ e.target.id ].greatest_marker ] ) {
          videos_status[ e.target.id ]._progress_markers[ videos_status[ e.target.id ].greatest_marker ] = true;
          dataLayer.push({
            "event": "videoPlayer",
            "videoAction": "Play %" + videos_status[ e.target.id ].greatest_marker,
            "videoTitle": videos_status[ e.target.id ].title
          });
        }
        break;

      case "play":
        dataLayer.push({
          "event": "videoPlayer",
          "videoAction": "Play",
          "videoTitle": videos_status[ e.target.id ].title
        });
        break;

      case "pause":
        dataLayer.push({
          "event": "videoPlayer",
          "videoAction": "Pause",
          "videoTitle": videos_status[ e.target.id ].title
        });
        break;

      case "ended":
        dataLayer.push({
          "event": "videoPlayer",
          "videoAction": "Finished",
          "videoTitle": videos_status[ e.target.id ].title
        });
        break;

      default:
        break;
    }
  }
}

module.exports = VideoTracking;
